import React from 'react';
import { Provider } from 'react-redux';
import { Router, Redirect, Route } from 'react-router';

import store from 'core/store';
import history from 'core/history';

import UsersPage from 'components/users/Page';
import CandidatesPage from 'components/candidates/Page';
import RecruitersPage from 'components/recruiters/Page';
import VacanciesPage from 'components/vacancies/Page';
import MatchesPage from 'components/matches/Page';
import LoginPage from 'containers/LoginPage';
import GenericNotFound from 'components/GenericNotFound'
import Header from 'containers/Header';
import App from 'containers/App';

import { detectAuth, requireAuth} from 'utils/authorization'
/*
  separating routes as workaround for compatibility with HMR
  https://github.com/reactjs/react-router-redux/issues/179#issuecomment-241771171
*/

const routes = (
  <Route path="" component={App}>
    <Redirect path='/' to='/login' />
    <Redirect path='/admin' to='/admin/candidates' />
    <Route path="login" component={detectAuth(LoginPage)} />
    <Route path="admin">
      <Route component={requireAuth(Header)}>
        <Route path="users" component={UsersPage.Container} />
        <Route path="candidates" component={CandidatesPage.Container} />
        <Route path="recruiters" component={RecruitersPage.Container} />
        <Route path="vacancies" component={VacanciesPage.Container} />
        <Route path="matches" component={MatchesPage.Container} />
      </Route>
    </Route>
    <Route path='*' exact={true} component={GenericNotFound} />
  </Route>
);

export default (props) => (
  <Provider store={store}>
    <Router history={history}>
      {routes}
    </Router>
  </Provider>
);



// WEBPACK FOOTER //
// ./src/core/root.js